"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const backendImport_1 = require("@front/backendImport");
const IAvatar_1 = __importDefault(require("@back/models/interfaces/IAvatar"));
const client_1 = require("@rws-framework/client");
require("../../../chat-frontend/chat-component");
const models_types_1 = require("@front/types/models.types");
const events_1 = require("@front/event/events");
const ChatService_1 = __importStar(require("@front/services/ChatService"));
const translations_1 = require("@front/application/globals/translations");
const chatSettings_types_1 = require("@front/types/chatSettings.types");
const StorageService_1 = __importStar(require("@front/services/StorageService"));
const ChatAudioHelper_1 = require("./helpers/ChatAudioHelper");
const ChatEventsHelper_1 = require("./helpers/ChatEventsHelper");
const WSService_audio_1 = __importStar(require("@front/services/WSService.audio"));
const SignalService_1 = __importStar(require("@front/services/SignalService"));
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const ConversationAgentService_1 = __importStar(require("@front/services/conversation/ConversationAgentService"));
//@ts-ignore                
let rwsTemplate = T.html `<div id="chat">     
    ${(0, fast_element_1.when)(x => x.isInit, (0, fast_element_1.html) `<chat-component            
            data-input-position="sticky"
            data-interaction-model="chat"
            data-api-url="/api/ai"
            data-use-stream="true"
            data-approach="rrr"
            data-overrides="${x => x.overrides}"
            data-custom-headers="${x => JSON.stringify(x.customHeaders)}"
            data-custom-teasers="${x => x.getTeasers()}"
            data-custom-config="${x => x.getConfig()}"
            data-custom-styles="{&quot;AccentHigh&quot;:&quot;#692b61&quot;,&quot;AccentLight&quot;:&quot;#f6d5f2&quot;,&quot;AccentDark&quot;:&quot;#5e3c7d&quot;,&quot;TextColor&quot;:&quot;#123f58&quot;,&quot;BackgroundColor&quot;:&quot;#e3e3e3&quot;,&quot;ForegroundColor&quot;:&quot;#4e5288&quot;,&quot;FormBackgroundColor&quot;:&quot;#f5f5f5&quot;,&quot;BorderRadius&quot;:&quot;10px&quot;,&quot;BorderWidth&quot;:&quot;3px&quot;,&quot;FontBaseSize&quot;:&quot;14px&quot;}"
            data-custom-branding="false"
            data-hide-history="true"            
            data-theme="light"
            data-text-typing="${x => x.typing}"
            compact="${x => x.compact ? 'true' : 'false'}"
            mini="${x => x.mini ? 'true' : 'false'}"
            fullscreen="${x => x.fullscreen ? 'true' : 'false'}"
            data-can-talk="${x => x.canTalk ? 'true' : 'false'}"
            data-web-search="${x => x.webSearchEnabled ? 'true' : 'false'}"
            data-deep-search="${x => x.deepSearchEnabled ? 'true' : 'false'}"
            data-writing-style="${x => JSON.stringify(x.writingStyles.length ? x.writingStyles : [])}"
            data-initial-messages="${x => x.injectedMessages ? JSON.stringify(x.injectedMessages) : '[]'}"
            data-convo-id="${x => x.conversationId}"
            data-selected-model="${x => x.selectedModel ? JSON.stringify(x.selectedModel) : ''}"
            data-selected-avatar="${x => x.selectedAvatar ? JSON.stringify({ id: x.selectedAvatar.id, name: x.selectedAvatar.name }) : ''}"
            data-ai-provider="${x => x.selectedAIProvider || ''}"
            data-inject-css="${x => x.injectCss}"
            @kdbPick="${(x, c) => x.handleKnowledgePickerUpdate(c.event)}"
            >            
        </chat-component>`, (0, fast_element_1.html) `<div class="choose-model"><h2 class="text-center">${'ai.chat.nomodel'.t()}</h2></div>`)}
</div>
 `;
require("./styles/layout.scss");
const styles = T.css `#chat {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  box-sizing: border-box;
}

chat-component {
  max-width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0;
  border-radius: 10px;
}

h3 {
  text-align: center;
  margin-top: 30px;
  font-size: 1.5rem;
  color: #333;
}

@media (max-width: 768px) {
  #chat {
    padding: 0 8px;
  }
  h3 {
    font-size: 1.2rem;
  }
  chat-component {
    padding: 8px;
  }
}`;
const shadowOptions = { "mode": "open" };
let ChatComponent = class ChatComponent extends client_1.RWSViewComponent {
    constructor(chatService, storageService, wsAudioService, signalService, popupService, conversationAgentService) {
        super();
        this.chatService = chatService;
        this.storageService = storageService;
        this.wsAudioService = wsAudioService;
        this.signalService = signalService;
        this.popupService = popupService;
        this.conversationAgentService = conversationAgentService;
        this.writingStyle = '';
        this.fullscreen = true;
        this.compact = false;
        this.mini = false;
        this.typing = false;
        this.injectCss = '';
        this.isRecording = false;
        this.currentAudioSessionId = null;
        this.customHeaders = {};
        this.knowledge = [];
        this.fullKnowledgeIds = [];
        this.writingStyles = [];
        this.selectedModel = null;
        this.selectedAIProvider = null;
        this.selectedAvatar = null;
        this.injectedMessages = [];
        this.webSearchEnabled = false;
        this.deepSearchEnabled = false;
        this.isInit = false;
        this.fullscan = false;
        this.canTalk = false;
        this.activeTutorialSection = null;
        this.autoTalkEnabled = false;
        this.autotalkSessionId = null;
        this.renderVar = 0;
        this.isTalking = false;
        this.knowledgePickerSignal = null;
        this.appChatSignal = null;
    }
    connectedCallback() {
        super.connectedCallback();
        this.knowledgePickerSignal = this.signalService.getSignal('knowledge-picker-signal', { initialValue: null });
        this.appChatSignal = this.signalService.getSignal('app-chat-signal', { initialValue: null });
        this.conversationAgentService.setOnSpeakingChanged((speaking) => {
            var _a;
            this.isTalking = speaking;
            (_a = this.appChatSignal) === null || _a === void 0 ? void 0 : _a.setValue({ command: speaking ? 'start-talk' : 'talk-ended' });
        });
        this.chatService.initialize(this);
        ChatEventsHelper_1.ChatEventsHelper.bindEvents.bind(this)();
        // Listen for writing style change events
        this.on(events_1.appEvents.frontChatWritingStyleChange, this.handleWritingStyleChange.bind(this));
        this.on(events_1.appEvents.triggerSelected, (event) => {
            var _a;
            switch (event.detail.type) {
                case 'style':
                    this.handleWritingStyleChange(new CustomEvent('dummy_style_change', { detail: { id: event.detail.id } }));
                    break;
                case 'knowledge':
                    (_a = this.knowledgePickerSignal) === null || _a === void 0 ? void 0 : _a.setValue({ command: 'pick', knowledgeIds: [event.detail.id] });
                    break;
                case 'project':
                    const projectId = event.detail.id.toString();
                    this.apiService.back.get('knowledge.list', { queryParams: { projectId: projectId } }).then((response) => {
                        var _a;
                        (_a = this.knowledgePickerSignal) === null || _a === void 0 ? void 0 : _a.setValue({ command: 'pick', knowledgeIds: response.data.map(k => k.id.toString()) });
                    });
                    break;
            }
        });
        if (this.apiService.token && this.apiService.token !== '') {
            this.customHeaders = {
                'Authorization': 'Bearer ' + this.apiService.token,
            };
        }
        else if (this.apiService.apiKey && this.apiService.apiKey !== '') {
            this.customHeaders = {
                'x-api-key': this.apiService.apiKey,
            };
        }
        ChatEventsHelper_1.ChatEventsHelper.sync.bind(this)();
        this.resetChat();
        this.$emit('app-chat-init', true);
        const savedSettings = this.storageService.get('ai.chatSettings');
        const tutorialVoice = this.storageService.get('tutorial_audio_voice');
        if (savedSettings) {
            this.chatSettings = JSON.parse(savedSettings);
        }
        else {
            this.chatSettings = chatSettings_types_1.DEFAULT_CHAT_SETTINGS;
        }
        if (tutorialVoice) {
            this.chatSettings = { ...this.chatSettings, voice: tutorialVoice };
        }
        // These values are now passed from the parent component, no need to load from storage
        // Update the chat service with the current values (this will update both state and config overrides)
        this.chatService.handleWebSearchChange(this.webSearchEnabled);
        this.chatService.handleDeepSearchChange(this.deepSearchEnabled);
        this.checkInit();
        if (this.activeTutorialSection) {
            this.chatService.getConfigService().updateOverrides({
                tutorialSection: this.activeTutorialSection
            });
        }
    }
    injectCssChanged(oldV, newV) {
        console.log({ oldV, newV });
    }
    checkInit() {
        if (!this.chatService) {
            return;
        }
        if ((this.chatService.getConfigService().getOverridesData().selectedModel || this.chatService.getConfigService().getOverridesData().avatar) && ((this.selectedModel && this.selectedModel.model) || this.selectedAvatar) && !this.isInit) {
            this.isInit = true;
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        // Reset tutorial-specific state so it doesn't leak into future chat sessions
        this.activeTutorialSection = null;
        // Restore chat settings to saved/default values (without tutorial voice override)
        const savedSettings = this.storageService.get('ai.chatSettings');
        if (savedSettings) {
            this.chatSettings = JSON.parse(savedSettings);
        }
        else {
            this.chatSettings = chatSettings_types_1.DEFAULT_CHAT_SETTINGS;
        }
        // Clear the tutorial section override from config payload
        this.chatService.getConfigService().updateOverrides({
            tutorialSection: null
        });
        this.chatService.cleanup();
    }
    injectedMessagesChanged(old, newVal) {
        // Template automatically re-renders when @observable injectedMessages changes
        // No additional action needed - the data-initial-messages attribute binding updates automatically
    }
    injectMsg(message) {
        // Check for duplicates based on content and timestamp (within 1 second window)
        const isDuplicate = this.injectedMessages.some(existingMsg => {
            const timeDiff = Math.abs(new Date(message.timestamp).getTime() - new Date(existingMsg.timestamp).getTime());
            return existingMsg.rawContent === message.rawContent &&
                existingMsg.isUserMessage === message.isUserMessage &&
                timeDiff < 1000; // Within 1 second window
        });
        if (!isDuplicate) {
            this.injectedMessages = [...this.injectedMessages, message];
            // Force the Azure chat component to process the new injected message
            // by temporarily marking isChatStarted as false so it will accept the new initialMessages
            const chatElement = this.getChatComponent();
            if (chatElement) {
                const wasStarted = chatElement.isChatStarted;
                chatElement.isChatStarted = false;
                chatElement.requestUpdate();
                // Restore the original state after a micro-task
                setTimeout(() => {
                    if (wasStarted) {
                        chatElement.isChatStarted = wasStarted;
                    }
                }, 0);
            }
        }
        else {
        }
    }
    handleWebSearchChange(checked) {
        this.webSearchEnabled = checked;
        this.$emit(events_1.appEvents.frontChatWebSearch, checked);
    }
    handleDeepSearchChange(checked) {
        this.deepSearchEnabled = checked;
        this.$emit(events_1.appEvents.frontChatDeepSearch, checked);
    }
    handleWritingStyleChange(event) {
        const trigger = event.detail;
        const styleId = trigger.id.toString();
        // Add to writingStyles array (similar to knowledge)
        if (!this.writingStyles.includes(styleId)) {
            this.writingStyles = [...this.writingStyles, styleId];
        }
        // Update both the component attribute and chat service overrides
        this.writingStyle = styleId; // Keep for backward compatibility
        this.chatService.getConfigService().updateOverrides({
            writingStyle: this.writingStyles
        });
    }
    writingStyleChanged(oldValue, newValue) {
        // Handle attribute change from external sources
        if (newValue !== oldValue && newValue) {
            // Parse if it's a JSON array, otherwise treat as single value
            let styles = [];
            try {
                styles = JSON.parse(newValue);
                if (!Array.isArray(styles)) {
                    styles = [newValue];
                }
            }
            catch (_a) {
                styles = [newValue];
            }
            this.writingStyles = styles;
            this.chatService.getConfigService().updateOverrides({
                writingStyle: styles
            });
        }
    }
    activeTutorialSectionChanged(oldValue, newValue) {
        if (this.chatService && this.activeTutorialSection) {
            this.chatService.getConfigService().updateOverrides({
                tutorialSection: this.activeTutorialSection
            });
        }
        this.checkInit();
    }
    handleWritingStyleRemoval(event) {
        const { styleId } = event.detail;
        // Remove from writingStyles array
        this.writingStyles = this.writingStyles.filter(style => String(style) !== String(styleId));
        // Update the chat service overrides
        this.chatService.getConfigService().updateOverrides({
            writingStyle: this.writingStyles
        });
        // Sync observables from service to update UI
        this.syncObservablesFromService();
    }
    writingStylesChanged(old, newVal) {
        if (!newVal || !this.isInit || old === newVal) {
            return;
        }
        const chatElement = this.getChatComponent();
        if (chatElement) {
            this.chatService.getConfigService().updateOverrides({
                writingStyle: newVal
            });
            this.syncObservablesFromService();
        }
    }
    async audioRecordingToggled(state) {
        ChatAudioHelper_1.ChatAudioHelper.audioRecordingHandle.bind(this)(state);
    }
    setModelData(modelData) {
        if (!modelData) {
            return;
        }
        if (!modelData.avatar) {
            this.selectedAvatar = null;
            this.chatService.getConfigService().updateOverrides({
                avatar: null
            });
        }
        this.chatService.getConfigService().updateOverrides({
            selectedModel: modelData
        });
        this.syncObservablesFromService();
        this.checkInit();
    }
    selectedModelChanged(old, newVal) {
        if (this.chatService && newVal) {
            if (this.selectedAvatar && newVal.avatar) {
                return;
            }
            if (newVal.avatar) {
                this.selectedAvatar = { id: newVal.avatar };
                this.chatService.getConfigService().updateOverrides({
                    avatar: newVal.avatar,
                    selectedModel: null
                });
            }
            else {
                // No avatar, set the model
                this.chatService.handleModelChange(newVal);
                this.overrides = this.chatService.getConfigService().getOverrides();
            }
        }
        this.checkInit();
    }
    selectedAIProviderChanged(old, newVal) {
        if (!newVal || !this.isInit || old === newVal) {
            return;
        }
        this.chatService.handleAIProviderChange(newVal);
        this.syncObservablesFromService();
    }
    selectedAvatarChanged(old, newVal) {
        if (!this.chatService) {
            return;
        }
        if (!newVal) {
            this.selectedAvatar = null;
            return;
        }
        // Always update the chat service, even if newVal is null
        const chatElement = this.getChatComponent();
        this.chatService.handleAvatarChange(newVal ? newVal.id : null, chatElement);
        this.$emit('chat:clean:model', true);
        this.syncObservablesFromService();
        this.checkInit();
    }
    knowledgeChanged(old, newVal) {
        if (!newVal || !this.isInit || old === newVal) {
            return;
        }
        const chatElement = this.getChatComponent();
        if (chatElement) {
            this.chatService.handleKnowledgeChange(newVal, chatElement);
            this.syncObservablesFromService();
        }
    }
    fullKnowledgeIdsChanged(old, newVal) {
        if (!newVal || !this.isInit || old === newVal) {
            return;
        }
        const chatElement = this.getChatComponent();
        if (chatElement) {
            this.chatService.handleFullKnowledgeChange(newVal, chatElement);
            this.syncObservablesFromService();
        }
    }
    fullscanChanged(old, newVal) {
        if (!newVal || !this.isInit || old === newVal) {
            return;
        }
        const chatElement = this.getChatComponent();
        if (chatElement) {
            this.chatService.handleFullscanChange(newVal, chatElement);
            this.syncObservablesFromService();
        }
    }
    handleKnowledgePickerUpdate(event) {
        const { selectedIds, fullKnowledgeIds } = event.detail;
        // Update the knowledge properties to trigger changes
        this.knowledge = selectedIds || [];
        this.fullKnowledgeIds = fullKnowledgeIds || [];
        // Emit the event up to the main chat page
        this.$emit('kdbPick', { selectedIds, fullKnowledgeIds });
    }
    webSearchEnabledChanged(old, newVal) {
        if (old === undefined || !this.isInit || old === newVal) {
            return;
        }
        // Save to storage
        this.storageService.set('ai.webSearchEnabled', newVal.toString());
        // Update state service
        const stateService = this.chatService.getStateService();
        stateService.webSearchEnabled = newVal;
        const chatElement = this.getChatComponent();
        if (chatElement) {
            this.chatService.handleWebSearchChange(newVal, chatElement);
            this.syncObservablesFromService();
        }
    }
    deepSearchEnabledChanged(old, newVal) {
        if (old === undefined || !this.isInit || old === newVal) {
            return;
        }
        // Save to storage
        this.storageService.set('ai.deepSearchEnabled', newVal.toString());
        // Update state service
        const stateService = this.chatService.getStateService();
        stateService.deepSearchEnabled = newVal;
        const chatElement = this.getChatComponent();
        if (chatElement) {
            this.chatService.handleDeepSearchChange(newVal, chatElement);
            this.syncObservablesFromService();
        }
    }
    resetChat() {
        const chatElement = this.getChatComponent();
        if (chatElement) {
            this.chatService.resetChat(chatElement);
        }
    }
    clearChat() {
        const chatElement = this.getChatComponent();
        if (chatElement) {
            this.chatService.clearChat(chatElement);
            this.chatService.getStateService().injectedMessages = [];
            this.injectedMessages = [];
        }
    }
    setConversationData(conversation, frontMessages = [], dontClear = false) {
        const chatElement = this.getChatComponent();
        if (chatElement) {
            if (!dontClear) {
                this.clearChat();
                if (conversation && conversation.messages && conversation.messages.length) {
                    this.chatService.getStateService().injectedMessages = frontMessages.length ? frontMessages : [];
                }
            }
            this.chatService.handleConversationChange(conversation, chatElement);
            this.syncObservablesFromService();
            this.renderVar += 1;
        }
    }
    syncToConversationModel() {
        this.chatService.syncToConversationModel();
        this.syncObservablesFromService();
    }
    hasModelMismatch() {
        return false; //fix
        return this.chatService.hasModelMismatch();
    }
    isChatVisible() {
        return ((this.selectedModel && this.selectedModel.model && this.selectedModel.model.value) || this.selectedAvatar) && this.isInit;
    }
    getTeasers() {
        if (!this.chatService) {
            return '';
        }
        return this.chatService.getConfigService().getTeasers();
    }
    getConfig() {
        setTimeout(() => {
            const chatElement = this.getChatComponent();
            chatElement === null || chatElement === void 0 ? void 0 : chatElement.requestUpdate();
        }, 0);
        return this.chatService.getConfigService().getConfig();
    }
    getChatComponent() {
        const chatElement = this.$('chat-component');
        if (!chatElement) {
            return null;
        }
        return chatElement;
    }
    syncObservablesFromService() {
        ChatEventsHelper_1.ChatEventsHelper.sync.bind(this)();
    }
    appendInputTextToChat(text, send = false, hidden = false) {
        const chatElement = this.getChatComponent();
        if (chatElement) {
            this.chatService.appendInputTextToChat(text, chatElement, send, hidden);
        }
    }
    addSimulatedAIMessage(text) {
        const chatElement = this.getChatComponent();
        if (chatElement) {
            chatElement.addSimulatedAIMessage(text);
        }
    }
    async playAudioFromText(text, options) {
        var _a;
        console.log('[app-chat] playAudioFromText', { text, voice: (_a = this.chatSettings) === null || _a === void 0 ? void 0 : _a.voice });
        const comp = this.getChatComponent();
        comp.toggleTalk(1);
        // Use provided language or get current language
        const languageCode = (options === null || options === void 0 ? void 0 : options.language) || (0, translations_1.getLanguage)();
        try {
            const resp = await this.apiService.back.post('audio.text-to-speech', {
                text,
                voiceId: this.chatSettings.voice,
                languageCode
            });
            console.log('[app-chat] text-to-speech response', resp);
            // Play the base64 MP3 audio
            if (resp && typeof resp === 'object' && 'file' in resp && resp.file) {
                ChatAudioHelper_1.ChatAudioHelper.playBase64Audio(resp.file, () => {
                    var _a;
                    comp.toggleTalk(0);
                    (_a = this.appChatSignal) === null || _a === void 0 ? void 0 : _a.setValue({ command: 'talk-ended' });
                }, () => {
                    var _a;
                    comp.toggleTalk(2);
                    (_a = this.appChatSignal) === null || _a === void 0 ? void 0 : _a.setValue({ command: 'start-talk' });
                });
            }
            else {
                console.warn('[app-chat] text-to-speech returned no file, resetting talk state');
                comp.toggleTalk(0);
            }
        }
        catch (error) {
            console.error('[app-chat] text-to-speech failed', error);
            comp.toggleTalk(0);
        }
    }
    async downloadAudioFromText(text, options) {
        const comp = this.getChatComponent();
        comp.toggleThreadLoading(true);
        // Use provided language or get current language
        const languageCode = (options === null || options === void 0 ? void 0 : options.language) || (0, translations_1.getLanguage)();
        const resp = await this.apiService.back.post('audio.text-to-speech', {
            text,
            voiceId: this.chatSettings.voice,
            languageCode
        });
        comp.toggleThreadLoading(false);
        // Download the base64 MP3 audio
        if (resp && typeof resp === 'object' && 'file' in resp && resp.file) {
            ChatAudioHelper_1.ChatAudioHelper.downloadBase64Audio(resp.file, text);
        }
    }
    updateToolData(toolName, toolData) {
        this.chatService.getConfigService().updateOverrides({
            toolData: {
                [toolName]: toolData
            }
        });
        this.syncObservablesFromService();
        const chatElement = this.getChatComponent();
        chatElement === null || chatElement === void 0 ? void 0 : chatElement.requestUpdate();
    }
    removeToolData(key) {
        const toolData = this.chatService.getConfigService().getOverridesData().toolData || {};
        delete toolData[key];
        this.chatService.getConfigService().updateOverrides({
            toolData
        });
        this.syncObservablesFromService();
        const chatElement = this.getChatComponent();
        chatElement === null || chatElement === void 0 ? void 0 : chatElement.requestUpdate();
    }
    getExternalSignal() {
        return this.appChatSignal;
    }
};
exports.ChatComponent = ChatComponent;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], ChatComponent.prototype, "writingStyle", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], ChatComponent.prototype, "fullscreen", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], ChatComponent.prototype, "compact", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], ChatComponent.prototype, "mini", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], ChatComponent.prototype, "typing", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], ChatComponent.prototype, "injectCss", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_g = typeof backendImport_1.IConversation !== "undefined" && backendImport_1.IConversation) === "function" ? _g : Object)
], ChatComponent.prototype, "conversation", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], ChatComponent.prototype, "conversationId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], ChatComponent.prototype, "conversationUid", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ChatComponent.prototype, "isRecording", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], ChatComponent.prototype, "currentAudioSessionId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_h = typeof Record !== "undefined" && Record) === "function" ? _h : Object)
], ChatComponent.prototype, "customHeaders", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ChatComponent.prototype, "knowledge", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ChatComponent.prototype, "fullKnowledgeIds", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ChatComponent.prototype, "writingStyles", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_j = typeof backendImport_1.ISelectedModel !== "undefined" && backendImport_1.ISelectedModel) === "function" ? _j : Object)
], ChatComponent.prototype, "selectedModel", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_k = typeof models_types_1.AIProviderFrontType !== "undefined" && models_types_1.AIProviderFrontType) === "function" ? _k : Object)
], ChatComponent.prototype, "selectedAIProvider", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_l = typeof IAvatar_1.default !== "undefined" && IAvatar_1.default) === "function" ? _l : Object)
], ChatComponent.prototype, "selectedAvatar", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ChatComponent.prototype, "injectedMessages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ChatComponent.prototype, "webSearchEnabled", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ChatComponent.prototype, "deepSearchEnabled", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ChatComponent.prototype, "isInit", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ChatComponent.prototype, "fullscan", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ChatComponent.prototype, "canTalk", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], ChatComponent.prototype, "overrides", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_m = typeof chatSettings_types_1.IChatSettings !== "undefined" && chatSettings_types_1.IChatSettings) === "function" ? _m : Object)
], ChatComponent.prototype, "chatSettings", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], ChatComponent.prototype, "activeTutorialSection", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ChatComponent.prototype, "autoTalkEnabled", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], ChatComponent.prototype, "autotalkSessionId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], ChatComponent.prototype, "renderVar", void 0);
exports.ChatComponent = ChatComponent = __decorate([
    (0, client_1.RWSView)('app-chat', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(ChatService_1.default)),
    __param(1, (0, client_1.RWSInject)(StorageService_1.default)),
    __param(2, (0, client_1.RWSInject)(WSService_audio_1.default)),
    __param(3, (0, client_1.RWSInject)(SignalService_1.default)),
    __param(4, (0, client_1.RWSInject)(PopupService_1.default)),
    __param(5, (0, client_1.RWSInject)(ConversationAgentService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof ChatService_1.ChatServiceInstance !== "undefined" && ChatService_1.ChatServiceInstance) === "function" ? _a : Object, typeof (_b = typeof StorageService_1.StorageServiceInstance !== "undefined" && StorageService_1.StorageServiceInstance) === "function" ? _b : Object, typeof (_c = typeof WSService_audio_1.WSServiceAudioInstance !== "undefined" && WSService_audio_1.WSServiceAudioInstance) === "function" ? _c : Object, typeof (_d = typeof SignalService_1.SignalServiceInstance !== "undefined" && SignalService_1.SignalServiceInstance) === "function" ? _d : Object, typeof (_e = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _e : Object, typeof (_f = typeof ConversationAgentService_1.ConversationAgentServiceInstance !== "undefined" && ConversationAgentService_1.ConversationAgentServiceInstance) === "function" ? _f : Object])
], ChatComponent);
ChatComponent.defineComponent();
